<template>
  <div id="joinUs">
    <!-- 页头 Banner -->
    <div class="page-header">
      <div class="page-header-inner">
        <h1 class="page-title">哈密市人才引进报名系统</h1>
        <p class="page-subtitle">哈密市人才集团 · 诚邀优秀人才加入</p>
      </div>
    </div>

    <!-- Tab 导航 -->
    <div class="tab-nav-wrap">
      <div class="tab-nav">
        <button
          class="tab-btn"
          :class="{ active: sub == 2 }"
          @click="changeTabFun(2)"
        >
          <div class="tab-icon-wrap">
            <svg class="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </div>
          <div class="tab-text-wrap">
            <span class="tab-label">招聘公告</span>
            <span class="tab-desc">查看最新招聘信息</span>
          </div>
        </button>
        <button
          class="tab-btn"
          :class="{ active: sub == 3 }"
          @click="changeTabFun(3)"
        >
          <div class="tab-icon-wrap">
            <svg class="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
          </div>
          <div class="tab-text-wrap">
            <span class="tab-label">报名通道</span>
            <span class="tab-desc">选择岗位立即报名</span>
          </div>
        </button>
        <button
          class="tab-btn"
          :class="{ active: sub == 4 }"
          @click="changeTabFun(4)"
        >
          <div class="tab-icon-wrap">
            <svg class="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
            </svg>
          </div>
          <div class="tab-text-wrap">
            <span class="tab-label">报名记录</span>
            <span class="tab-desc">查看我的报名状态</span>
          </div>
        </button>
      </div>
    </div>

    <!-- 内容区 -->
    <div class="content-wrap">

      <!-- 招聘公告 -->
      <transition name="fade-slide">
        <div class="panel notice-panel" v-show="sub == 2">
          <div class="notice-header">
            <div class="notice-icon-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
              </svg>
            </div>
            <h2 class="notice-title">{{ noticeInfo.title }}</h2>
          </div>
          <div class="notice-divider"></div>
          <div class="notice-body">
            <div class="notice-ct" v-html="noticeInfo.consultationInfo"></div>
            <div class="notice-ct notice-ct-main" v-html="noticeInfo.contents"></div>
          </div>
          <!-- 公告附件 -->
          <div class="notice-attachments" v-if="noticeInfo.attachments && noticeInfo.attachments.length">
            <div class="notice-attachments-title">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"/>
              </svg>
              附件
            </div>
            <ul class="notice-attachment-list">
              <li
                class="notice-attachment-item"
                v-for="(item, index) in noticeInfo.attachments"
                :key="index"
                @click="downloadAttachment(item)"
              >
                <svg class="file-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <span class="file-name">{{ item.fileName }}</span>
              </li>
            </ul>
          </div>
          <div class="notice-footer">
            <button class="btn-outline" @click="changeTabFun(3)">前往报名通道</button>
          </div>
        </div>
      </transition>

      <!-- 报名通道 -->
      <transition name="fade-slide">
        <div class="panel thorough-panel" v-show="sub == 3">
          <div class="panel-header">
            <h2 class="panel-title">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              岗位列表
            </h2>
            <span class="panel-subtitle">请选择意向岗位后立即报名</span>
          </div>
          <div class="comapnyPost">
            <jobList :talentIntroductionId="talentIntroductionInfoId"></jobList>
          </div>
        </div>
      </transition>

      <!-- 报名记录 -->
      <transition name="fade-slide">
        <div class="panel record-panel" v-show="sub == 4">
          <div class="panel-header">
            <h2 class="panel-title">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
              </svg>
              我的报名记录
            </h2>
          </div>

          <!-- 未登录 -->
          <div v-if="!userInfo.phone" class="empty-state">
            <div class="empty-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <p class="empty-title">您尚未登录</p>
            <p class="empty-desc">登录后即可查看报名记录</p>
            <button class="btn-primary" @click="goToLogin">登录 / 注册</button>
          </div>

          <!-- 暂无记录 -->
          <div v-else-if="!recordInfo.nameOfEmployer" class="empty-state">
            <div class="empty-icon empty-icon--info">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <p class="empty-title">暂无报名记录</p>
            <p class="empty-desc">您还未提交任何报名申请</p>
            <button class="btn-outline" @click="changeTabFun(3)">前往报名通道</button>
          </div>

          <!-- 报名记录详情 -->
          <div v-else class="record-content">
            <!-- 审核进度 -->
            <div class="status-card" :class="statusCardClass">
              <div class="status-card-left">
                <div class="status-icon-wrap">
                  <svg v-if="recordInfo.status === 2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <svg v-else-if="recordInfo.status === 0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <div>
                  <div class="status-label">当前状态</div>
                  <div class="status-name">{{ recordInfo.statusName }}</div>
                </div>
              </div>
              <div class="status-tag-wrap">
                <span class="status-tag" :class="statusTagClass">{{ recordInfo.statusName }}</span>
              </div>
            </div>

            <!-- 步骤条 -->
            <div class="steps-wrap">
              <div class="step-item" :class="{ 'step-done': true }">
                <div class="step-circle step-circle--done">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>
                </div>
                <div class="step-label">提交申请</div>
              </div>
              <div class="step-line" :class="{
                'step-line--done': recordInfo.status >= 1 || recordInfo.status === 0,
                'step-line--rejected': recordInfo.status === 0
              }"></div>
              <div class="step-item" :class="{
                'step-done': recordInfo.status >= 1 || recordInfo.status === 0,
                'step-active': recordInfo.status === 1,
                'step-rejected': recordInfo.status === 0
              }">
                <div class="step-circle" :class="{
                  'step-circle--done': recordInfo.status >= 1 && recordInfo.status !== 0,
                  'step-circle--active': recordInfo.status === 1,
                  'step-circle--rejected': recordInfo.status === 0
                }">
                  <svg v-if="recordInfo.status === 0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 18L18 6M6 6l12 12"/></svg>
                  <svg v-else-if="recordInfo.status === 1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                  <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>
                </div>
                <div class="step-label">{{ recordInfo.status === 0 ? '审核不通过' : '审核中' }}</div>
              </div>
              <div class="step-line" :class="{
                'step-line--done': recordInfo.status === 2,
                'step-line--hidden': recordInfo.status === 0
              }"></div>
              <div class="step-item" :class="{
                'step-done': recordInfo.status === 2,
                'step-hidden': recordInfo.status === 0
              }">
                <div class="step-circle" :class="{
                  'step-circle--done': recordInfo.status === 2
                }">
                  <svg v-if="recordInfo.status === 2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>
                  <span v-else>3</span>
                </div>
                <div class="step-label">审核完成</div>
              </div>
            </div>

            <!-- 报名信息 -->
            <div class="record-info-block">
              <div class="record-info-section-title">报名信息</div>
              <div class="record-info-table">
                <div class="record-info-row">
                  <span class="ril">报名单位</span>
                  <span class="riv">{{ recordInfo.nameOfEmployer || '—' }}</span>
                  <span class="ril">岗位类别</span>
                  <span class="riv">{{ recordInfo.jobCategory || '—' }}</span>
                </div>
                <div class="record-info-row">
                  <span class="ril">专业名称</span>
                  <span class="riv riv--wide">{{ recordInfo.professionalName || '—' }}</span>
                </div>
                <div class="record-info-row">
                  <span class="ril">手机号码</span>
                  <span class="riv">{{ maskedPhone }}</span>
                  <span class="ril">审核时间</span>
                  <span class="riv">{{ recordInfo.reviewedTime || '—' }}</span>
                </div>
                <div class="record-info-row">
                  <span class="ril">审核状态</span>
                  <span class="riv">
                    <span class="status-tag" :class="statusTagClass">{{ recordInfo.statusName }}</span>
                  </span>
                </div>
              </div>
            </div>

            <!-- 审核意见（仅不通过时显示） -->
            <div class="rejection-card" v-if="recordInfo.status === 0">
              <div class="rejection-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
                审核意见
              </div>
              <div class="rejection-body">{{ recordInfo.reviewComments || '暂无说明' }}</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { getMyRegistrationInfo, getRecruitmentAnnouncement, getDictData, getTalentIntroductionEnterprises, getUserInfo } from "@/api/index.js";
import jobList from './component/job_list.vue';
export default {
  name: "joinUs",
  components: {
    jobList,
  },
  data() {
    return {
      info: {},
      sub: 2,
      noticeInfo: {},
      enterpriseList: [],
      employerList: [],
      talentIntroductionInfoId: '',
      recruitmentPositions: '',
      backgroundTypeList: [],
      baseUrl: '',
      userInfo: {},
      recordInfo: {},
    }
  },
  computed: {
    tabIndicatorStyle() {
      const map = { 2: 0, 3: 1, 4: 2 };
      const idx = map[this.sub] || 0;
      return { transform: `translateX(${idx * 100}%)` };
    },
    statusCardClass() {
      if (this.recordInfo.status === 2) return 'status-card--approved';
      if (this.recordInfo.status === 0) return 'status-card--rejected';
      return 'status-card--pending';
    },
    statusTagClass() {
      if (this.recordInfo.status === 2) return 'tag-approved';
      if (this.recordInfo.status === 0) return 'tag-rejected';
      return 'tag-pending';
    },
    maskedPhone() {
      const p = this.recordInfo.phone || '';
      if (p.length === 11) return p.slice(0, 3) + '****' + p.slice(7);
      return p || '—';
    }
  },
  created() {
    let get_query = this.$route.query;
    this.talentIntroductionInfoId = get_query.id || ''
  },
  mounted() {
    this.baseUrl = process.env.VUE_APP_BASE_API + '/webApi/common/upload'
    if (this.$route.query.sub) {
      this.sub = parseInt(this.$route.query.sub)
    }
    getUserInfo().then(res => {
      if (res.code == 200) {
        this.userInfo = res.data
      }
      if (this.sub === 4) {
        this.getRegistrationInfo()
      }
    })
    this.getRecruitmentAnnouncement()
    this.getTalentIntroductionEnterprises()
  },
  methods: {
    goToLogin() {
      this.$router.push({
        path: '/login',
        query: { redirect: '/joinUs?id=' + this.talentIntroductionInfoId + '&sub=4' }
      })
    },
    getRegistrationInfo() {
      if (!this.userInfo.phone) return;
      getMyRegistrationInfo({
        talentIntroductionId: this.talentIntroductionInfoId,
      }).then(res => {
        if (!res.data) { this.recordInfo = {}; return; }
        if (res.data.status === 0) res.data.statusName = '审核不通过';
        else if (res.data.status === 1) res.data.statusName = '审核中';
        else if (res.data.status === 2) res.data.statusName = '审核通过';
        this.recordInfo = res.data
      })
    },
    getDictData(dictType) {
      getDictData({ dictType }).then(res => {
        if (dictType == 'background_type_two') {
          this.backgroundTypeList = res.rows
        }
      })
    },
    changeTabFun(index) {
      this.sub = index
      if (index === 4) this.getRegistrationInfo();
    },
    getRecruitmentAnnouncement() {
      getRecruitmentAnnouncement({ id: this.$route.query.id }).then(res => {
        this.noticeInfo = res.data
      })
    },
    downloadAttachment(item) {
      if (item && item.fileUrl) {
        window.open(item.fileUrl, '_blank')
      }
    },
    getTalentIntroductionEnterprises() {
      getTalentIntroductionEnterprises({
        id: this.$route.query.id,
        type: 0
      }).then(res => {
        this.enterpriseList = res.rows
      })
    },
  }
};
</script>

<style lang="scss">
/* ========== 全局重置 ========== */
#joinUs {
  width: 100%;
  min-height: 100vh;
  background: #F0F9FF;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;

  /* ========== 页头 ========== */
  .page-header {
    background: linear-gradient(135deg, #0369A1 0%, #0284C7 50%, #0EA5E9 100%);
    padding: 48px 0 52px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -60px; right: -60px;
      width: 300px; height: 300px;
      border-radius: 50%;
      background: rgba(255,255,255,0.06);
    }
    &::after {
      content: '';
      position: absolute;
      bottom: -80px; left: -40px;
      width: 260px; height: 260px;
      border-radius: 50%;
      background: rgba(255,255,255,0.04);
    }

    .page-header-inner {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 24px;
      position: relative;
      z-index: 1;
    }

    .page-title {
      font-size: 32px;
      font-weight: 700;
      color: #fff;
      margin: 0 0 8px;
      letter-spacing: 2px;
    }

    .page-subtitle {
      font-size: 15px;
      color: rgba(255,255,255,0.8);
      margin: 0;
      letter-spacing: 1px;
    }
  }

  /* ========== Tab 导航 ========== */
  .tab-nav-wrap {
    background: linear-gradient(180deg, #0257891a 0%, #ffffff 100%);
    border-bottom: 1px solid #BAE6FD;
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 0 0 0 0;
  }

  .tab-nav {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 24px;
    display: flex;
    gap: 16px;
    position: relative;
  }

  .tab-btn {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1;
    padding: 18px 24px;
    background: #fff;
    border: 2px solid #E2EEF7;
    border-radius: 14px;
    cursor: pointer;
    position: relative;
    transition: all 0.25s ease;
    box-shadow: 0 2px 8px rgba(3, 105, 161, 0.06);
    text-align: left;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      left: 0; top: 0; bottom: 0;
      width: 4px;
      background: #CBD5E1;
      border-radius: 4px 0 0 4px;
      transition: background 0.25s ease;
    }

    .tab-icon-wrap {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      background: #F1F5F9;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: all 0.25s ease;

      .tab-icon {
        width: 22px;
        height: 22px;
        color: #64748B;
        transition: color 0.25s ease;
      }
    }

    .tab-text-wrap {
      display: flex;
      flex-direction: column;
      gap: 3px;

      .tab-label {
        font-size: 20px;
        font-weight: 600;
        color: #475569;
        transition: color 0.25s ease;
        line-height: 1.2;
      }

      .tab-desc {
        font-size: 12px;
        color: #94A3B8;
        transition: color 0.25s ease;
        line-height: 1.2;
      }
    }

    &:hover {
      border-color: #7DD3FC;
      box-shadow: 0 4px 16px rgba(3, 105, 161, 0.12);
      transform: translateY(-1px);

      &::before {
        background: #7DD3FC;
      }

      .tab-label {
        color: #0369A1;
      }
    }

    &.active {
      background: linear-gradient(135deg, #0369A1 0%, #0284C7 100%);
      border-color: #0369A1;
      box-shadow: 0 6px 20px rgba(3, 105, 161, 0.35);
      transform: translateY(-2px);

      &::before {
        background: rgba(255,255,255,0.5);
      }

      .tab-icon-wrap {
        background: rgba(255,255,255,0.2);

        .tab-icon {
          color: #fff;
        }
      }

      .tab-label {
        color: #fff;
      }

      .tab-desc {
        color: rgba(255,255,255,0.75);
      }
    }
  }

  /* ========== 内容区 ========== */
  .content-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 32px 24px 64px;
  }

  /* ========== 通用面板 ========== */
  .panel {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 16px rgba(3, 105, 161, 0.08);
    overflow: hidden;
  }

  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 32px;
    border-bottom: 1px solid #E0F2FE;

    .panel-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 18px;
      font-weight: 600;
      color: #0C4A6E;
      margin: 0;

      svg {
        width: 20px;
        height: 20px;
        color: #0369A1;
      }
    }

    .panel-subtitle {
      font-size: 13px;
      color: #94A3B8;
    }
  }

  /* ========== 招聘公告 ========== */
  .notice-panel {
    .notice-header {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 28px 40px 20px;
    }

    .notice-icon-wrap {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: linear-gradient(135deg, #0369A1, #0EA5E9);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      svg {
        width: 24px;
        height: 24px;
        color: #fff;
      }
    }

    .notice-title {
      font-size: 22px;
      font-weight: 700;
      color: #0C4A6E;
      margin: 0;
      line-height: 1.4;
    }

    .notice-divider {
      height: 1px;
      background: linear-gradient(to right, #0369A1 0%, #E0F2FE 60%, transparent 100%);
      margin: 0 40px;
    }

    .notice-body {
      padding: 28px 40px 40px;
    }

    .notice-footer {
      display: flex;
      justify-content: center;
      padding: 30px 0 60px 0;
    }

    .notice-ct {
      font-size: 15px;
      color: #334155;
      line-height: 1.8;

      p {
        margin-bottom: 12px;
        text-indent: 2em;
      }

      strong {
        color: #0369A1;
      }

      &.notice-ct-main {
        margin-top: 20px;
      }
    }
  }

  /* ========== 报名通道 ========== */
  .thorough-panel {
    .comapnyPost {
      padding: 8px 16px 16px;
    }
  }

  /* ========== 报名记录 ========== */
  .record-panel {
    .record-content {
      padding: 24px 32px 36px;
    }
  }

  /* ========== 空状态 ========== */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 24px;

    .empty-icon {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      background: #E0F2FE;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      svg {
        width: 36px;
        height: 36px;
        color: #0369A1;
      }

      &--info {
        background: #F1F5F9;
        svg { color: #94A3B8; }
      }
    }

    .empty-title {
      font-size: 17px;
      font-weight: 600;
      color: #1E293B;
      margin: 0 0 8px;
    }

    .empty-desc {
      font-size: 14px;
      color: #94A3B8;
      margin: 0 0 24px;
    }
  }

  .btn-primary {
    background: linear-gradient(135deg, #0369A1, #0EA5E9);
    color: #fff;
    border: none;
    padding: 12px 32px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.15s;
    letter-spacing: 1px;

    &:hover { opacity: 0.9; transform: translateY(-1px); }
    &:active { transform: translateY(0); }
  }

  .btn-outline {
    background: #fff;
    color: #0369A1;
    border: 1.5px solid #0369A1;
    padding: 11px 32px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, transform 0.15s;
    letter-spacing: 1px;

    &:hover {
      background: #0369A1;
      color: #fff;
      transform: translateY(-1px);
    }
  }

  /* ========== 状态卡片 ========== */
  .status-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-radius: 10px;
    margin-bottom: 28px;
    border-left: 4px solid;

    &--approved {
      background: #F0FDF4;
      border-color: #22C55E;
      .status-name { color: #15803D; }
      .status-label { color: #4ADE80; }
      .status-icon-wrap { background: #DCFCE7; svg { color: #22C55E; } }
    }
    &--rejected {
      background: #FFF1F2;
      border-color: #F43F5E;
      .status-name { color: #BE123C; }
      .status-label { color: #FDA4AF; }
      .status-icon-wrap { background: #FFE4E6; svg { color: #F43F5E; } }
    }
    &--pending {
      background: #FFFBEB;
      border-color: #F59E0B;
      .status-name { color: #B45309; }
      .status-label { color: #FCD34D; }
      .status-icon-wrap { background: #FEF3C7; svg { color: #F59E0B; } }
    }

    .status-card-left {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .status-icon-wrap {
      width: 44px;
      height: 44px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg { width: 22px; height: 22px; }
    }

    .status-label {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 2px;
    }

    .status-name {
      font-size: 16px;
      font-weight: 700;
    }
  }

  /* ========== 步骤条 ========== */
  .steps-wrap {
    display: flex;
    align-items: center;
    padding: 0 40px;
    margin-bottom: 32px;

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
      transition: opacity 0.2s;

      &.step-hidden { opacity: 0.25; }
    }

    .step-circle {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #E2E8F0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 600;
      color: #94A3B8;
      transition: all 0.3s ease;

      svg { width: 18px; height: 18px; }

      &--done {
        background: #0369A1;
        color: #fff;
        svg { color: #fff; }
        box-shadow: 0 4px 12px rgba(3, 105, 161, 0.35);
      }

      &--active {
        background: #F59E0B;
        color: #fff;
        svg { color: #fff; }
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.35);
        animation: pulse-amber 2s infinite;
      }

      &--rejected {
        background: #F43F5E;
        color: #fff;
        svg { color: #fff; }
        box-shadow: 0 4px 12px rgba(244, 63, 94, 0.35);
      }
    }

    .step-label {
      font-size: 13px;
      color: #64748B;
      white-space: nowrap;
      font-weight: 500;
    }

    .step-line {
      flex: 1;
      height: 3px;
      background: #E2E8F0;
      border-radius: 2px;
      margin: 0 8px;
      margin-bottom: 28px;
      transition: background 0.3s ease;

      &--done { background: #0369A1; }
      &--rejected { background: #F43F5E; }
      &--hidden { opacity: 0.2; }
    }
  }

  @keyframes pulse-amber {
    0%, 100% { box-shadow: 0 4px 12px rgba(245, 158, 11, 0.35); }
    50% { box-shadow: 0 4px 20px rgba(245, 158, 11, 0.6); }
  }

  /* ========== 报名信息表格 ========== */
  .record-info-block {
    margin-bottom: 24px;

    .record-info-section-title {
      font-size: 13px;
      font-weight: 600;
      color: #94A3B8;
      letter-spacing: 2px;
      text-transform: uppercase;
      margin-bottom: 12px;
      padding-left: 2px;
    }

    .record-info-table {
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
    }

    .record-info-row {
      display: flex;
      align-items: stretch;
      border-bottom: 1px solid #F1F5F9;

      &:last-child { border-bottom: none; }
      &:nth-child(even) { background: #FAFCFF; }

      .ril {
        width: 100px;
        min-width: 100px;
        padding: 13px 16px;
        font-size: 13px;
        color: #94A3B8;
        font-weight: 500;
        background: #F8FAFC;
        border-right: 1px solid #F1F5F9;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        line-height: 1.4;
      }

      .riv {
        flex: 1;
        padding: 13px 18px;
        font-size: 14px;
        color: #1E293B;
        font-weight: 500;
        display: flex;
        align-items: center;
        line-height: 1.4;
        border-right: 1px solid #F1F5F9;

        &:last-child { border-right: none; }

        &--wide {
          flex: 3;
        }
      }
    }
  }

  /* ========== 状态标签 ========== */
  .status-tag-wrap {
    flex-shrink: 0;
  }

  .status-tag {
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.5px;

    &.tag-approved {
      background: #DCFCE7;
      color: #15803D;
      border: 1px solid #BBF7D0;
    }
    &.tag-rejected {
      background: #FFE4E6;
      color: #BE123C;
      border: 1px solid #FECDD3;
    }
    &.tag-pending {
      background: #FEF3C7;
      color: #92400E;
      border: 1px solid #FDE68A;
    }
  }

  /* ========== 审核意见卡片 ========== */
  .rejection-card {
    background: #FFF1F2;
    border: 1px solid #FECDD3;
    border-left: 4px solid #F43F5E;
    border-radius: 10px;
    padding: 16px 20px;

    .rejection-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 600;
      color: #BE123C;
      margin-bottom: 10px;

      svg { width: 16px; height: 16px; color: #F43F5E; }
    }

    .rejection-body {
      font-size: 14px;
      color: #9F1239;
      line-height: 1.7;
    }
  }

  /* ========== 过渡动画 ========== */
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
  .fade-slide-enter {
    opacity: 0;
    transform: translateY(12px);
  }
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }
}
</style>

<style lang="scss">
/* 覆盖 el-menu 等组件样式 */
.thorough {
  .el-menu { width: 300px; }
  .el-menu-item-group__title { padding: 0; }
}
</style>

<style lang="scss" scoped>
/* ========== 公告附件 ========== */
.notice-attachments {
  margin: 0 40px;
  padding: 20px 24px;
  background: #F8FAFC;
  border: 1px solid #E0F2FE;
  border-radius: 10px;

  .notice-attachments-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #0C4A6E;
    margin-bottom: 14px;

    svg {
      width: 18px;
      height: 18px;
      color: #0369A1;
    }
  }

  .notice-attachment-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .notice-attachment-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #fff;
    border: 1px solid #E2EEF7;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;

    .file-icon {
      width: 18px;
      height: 18px;
      color: #64748B;
      flex-shrink: 0;
      transition: color 0.2s ease;
    }

    .file-name {
      font-size: 14px;
      color: #334155;
      line-height: 1.5;
      word-break: break-all;
      transition: color 0.2s ease;
    }

    &:hover {
      border-color: #7DD3FC;
      box-shadow: 0 2px 8px rgba(3, 105, 161, 0.1);

      .file-icon,
      .file-name {
        color: #0369A1;
      }
    }
  }
}
</style>
